import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiStack } from '../../../components';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { systemColor } from '../../../theme/systemColor';
var AccountPostingTab = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var AccountPostingArray = [{
            id: '01',
            ProductName: 'Purchase',
            SKUCode: 'BM9090',
            DebitAmount: '00.00',
            CreditAmount: '00.00'
        }, {
            id: '02',
            ProductName: 'Purchase',
            SKUCode: 'BM9090',
            DebitAmount: '00.00',
            CreditAmount: '00.00'
        }];
    var PostingDetails = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '0px',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'DebitAmount',
                    label: 'Debit amount :',
                    columnSize: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'CreditAmount',
                    label: 'Credit amount :',
                    columnSize: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remark',
                    label: 'Remark :',
                    columnSize: 12,
                    multiline: true,
                    minRows: 3
                }]
        }];
    var accountPostingColumn = [{
            field: 'Account',
            headerName: 'Account',
            minWidth: 180,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row, _params$row2;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Account), /*#__PURE__*/ React.createElement(Typography, {
                        color: systemColor.lightGrey,
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.code));
                }
            }
        }, {
            field: 'DebitAmount',
            headerName: 'Debit Amount (₹)',
            minWidth: 200,
            headerAlign: 'right',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'CreditAmount',
            headerName: 'Credit Amount (₹)',
            minWidth: 200,
            headerAlign: 'right',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'Remark',
            headerName: 'Remark',
            headerAlign: 'left',
            disableColumnMenu: true,
            minWidth: 420,
            editable: true
        }];
    var formData = [{
            type: FormItemTypes.List,
            name: 'AcountPosting',
            columnSize: 12,
            variant: 'comfortable',
            value: AccountPostingArray,
            disableCheckboxSelection: true,
            columns: [{
                    field: 'AcountPosting',
                    flex: 1,
                    renderCell: function (params) {
                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                            variant: "h3"
                        }, params.row.ProductName), /*#__PURE__*/ React.createElement(Typography, {
                            variant: "h6",
                            color: "secondary"
                        }, params.row.SKUCode ? '#' + params.row.SKUCode : ''));
                    }
                }],
            elements: PostingDetails
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: '20px 24px'
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    })) : /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: '20px 24px'
        }
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Posting Details",
        isCollapsible: true,
        columns: accountPostingColumn,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                aggregation: {
                    model: {
                        DebitAmount: 'sum',
                        CreditAmount: 'sum'
                    }
                }
            }
        },
        disableAddRow: true,
        disableDeleteRow: true,
        rows: [{
                id: '01',
                Account: 'Purchase',
                code: 'BM9090',
                DebitAmount: '00.00',
                CreditAmount: '00.00'
            }, {
                id: '02',
                Account: 'Purchase',
                code: 'BM9090',
                DebitAmount: '00.00',
                CreditAmount: '00.00'
            }]
    }));
};
export default AccountPostingTab;
